import { CustomLabel } from '@mindmemobile/mm-shared-global';
import styled from 'styled-components'; 

export const MembershipOptionWrapper = styled.div`
    .option-lock {
        height: 21px;
        width: 15px;
        margin-bottom: 3px;
    }
    .option-table-select {
        .header {
            width: 180px;
            height: 30px;
            border: 1px solid #ccc;
            border-radius: 4px;
            text-align: left;
            font-size: 14px;
            padding: 4px 10px;
        }
        .select-header-icon {
            height: 25px;
            border-left: 0px;
            color: #aaa;
        }
    }
    .collapsed-labels {
        margin-top: 30px;
        &.setup {
            > label {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
            }
        }
    }
    .program-table table.styled-table {
        thead th {
            font-weight: 700;
            text-align: left;
        }
        td {
            text-align: left;
        }
        ${CustomLabel} {
            font-size: 14px;
            font-weight: 400;
            color: #555;
        }
        td.pricing-option {
            label {
                font-weight: 600;
                color: #777;
            }
        }
    }
    .usage-icon {
        img {
            height: 35px;
            width: 33px;
        }
    }
`;

export const UsageBodyWrapper = styled.div`
    width: 100%;
    .usage-labels {
        label {
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
        }
    }
    .usage-header {
        margin-bottom: 30px;
        margin-top: 50px;

        label {
            margin-right: 10px;
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
        }
    }
    .usage-content {
        padding-left: 32px;
        > div.error-border {
            max-width: 600px;
        }
    }
    .usage__control {
        max-width: 600px;
        min-height: 40px;
        max-height: 150px;
    }
    .usage__menu {
        max-width: 600px;
    }
    .age-limit-chkbox {
        color: #777;
    }
    .usage-table {
        table thead th {
            font-weight: 700;
        }
        th:first-child {
            text-align: left;
        }
    }
    .add-benefit {
        height: 14px;
        width: 18px;
        margin-bottom: 2px;
        margin-right: 4px;
    }
    .fa.fa-dark-grey.clickable.fa-chevron-right {
        margin-top: 3px;
    }
    .usage-input {
        width: 120px;
        height: 30px;
    }
`;
